import * as d3 from 'd3'
import { get_absolute_coord, pad_number } from './helper.js'
import { color_dict, header_style, data_path, bg_img_style } from './constant.js'
import { frame_info } from './variable.js'

export function gen_header(header) {

  let benign_text = header
    .append('text')
    .text('Benign')
    .style('fill', color_dict['benign'])
    .style('font-weight', 'bold')

  let plus_text = header
    .append('text')
    .attr('id', 'plus-text')
    .text('+')
    .style('fill', 'white')
    .style('font-weight', 'bold')
    .style('transform', 'translate(0px, 0px)')
    .attr('x', 66.5)
    .attr('y', 20)

  let attacked_text = header
    .append('text')
    .text('Attacked')
    .attr('id', 'attacked-text')
    .style('fill', color_dict['attacked'])
    .style('font-weight', 'bold')
    .style('transform', 'translate(0px, 0px)')
    .attr('x', 80)
    .attr('y', 21)

  // Arrange the texts
  let arrange_components = [benign_text, plus_text, attacked_text]
  let x = header_style['start']
  arrange_components.forEach(e => {
    e.style('transform', 'translate(' + x + 'px, 1.3rem)')
    let [x1, y1, x2, y2] = get_absolute_coord(e)
    let w = Math.abs(x2 - x1)
    x = x + w + header_style['between']
  })

  // Set the rectangle width
  x = x + header_style['end'] - header_style['between']
  header.select('.pose-view-header-rect').style('width', x + 'px')

  // Move the header
  header.style('transform', 'translate(0px, 3px)')
}

export function gen_background(background, header) {
  // Add background image
  let bg_img = background
    .append('image')
    .attr('id', 'overlap-view-bg-img')
    .attr('href', `${data_path['benign_frame_dir']}/frame-${pad_number(frame_info['curr'], 3, 0)}.png`)
    .style('width', bg_img_style['overlap']['width'] + 'px')
    .style('height', bg_img_style['overlap']['height'] + 'px')
    .style('transform', 'translate(1px, 0px)')
    .attr('preserveAspectRatio', 'xMinYMin meet')

  // Move the background image
  let [x1, y1, x2, y2] = get_absolute_coord(header.select('.pose-view-header-rect'))
  let h = Math.abs(y1 - y2)
  bg_img.style('transform', 'translate(0px,' + h + 'px)')

  // Add background mask
  let p = 1.5
  let bg_img_mask = background
    .append('rect')
    .attr('id', 'overlap-view-bg-img-mask')
    .style('width', (bg_img_style['overlap']['width'] - p) + 'px')
    .style('height', bg_img_style['overlap']['height'] + 'px')
    .style('fill', 'white')
    .style('opacity', 0.7)
    .style('stroke', color_dict['bg-img-border'])
    .style('stroke-width', bg_img_style['overlap']['stroke-width'] + 'px')
    .style('transform', `translate(${p}px, ${h}px)`)

  // Add background image border
  let bg_img_border = background
    .append('rect')
    .attr('id', 'overlap-view-bg-img-border')
    .style('width', (bg_img_style['overlap']['width'] - p) + 'px')
    .style('height', bg_img_style['overlap']['height'] + 'px')
    .style('fill', 'transparent')
    .style('stroke', color_dict['bg-img-border'])
    .style('stroke-width', bg_img_style['overlap']['stroke-width'] + 'px')
    .style('transform', `translate(${p}px, ${h}px)`)

}

export function set_view_size(header) {

  // Get width and height of the view
  let [x1_hd, y1_hd, x2_hd, y2_hd] = get_absolute_coord(header)
  let h_text = 50
  let w_svg = bg_img_style['overlap']['width'] + 5
  let h_svg = Math.abs(y1_hd - y2_hd) + bg_img_style['overlap']['height'] + h_text
 
  // Set width and height of the view
  d3.select('#overlap-view')
    .style('width', w_svg + 'px')
    .style('height', h_svg + 'px')
  d3.select('#overlap-view-svg')
    .style('width', w_svg + 'px')
    .style('height', h_svg + 'px')

  // Location
  d3.select('#plus-text')
    .style('transform', 'translate(0px, 0px)')
  d3.select('#attacked-text')
    .style('transform', 'translate(0px, 0px)')
}

export function gen_frame_number(header) {

  // Generate g for writing the frame number
  let frame_number_g = d3.select('#overlap-view-svg')
    .append('g')
    .attr('id', 'g-overlap-frame-number')
  
  // Move g
  let [x1_hd, y1_hd, x2_hd, y2_hd] = get_absolute_coord(header)
  let x = bg_img_style['overlap']['width'] / 2 - 35
  let y = Math.abs(y1_hd - y2_hd) + bg_img_style['overlap']['height'] + 30
  frame_number_g.style('transform', `translate(${x}px, ${y}px)`)

  // Write frame number
  frame_number_g
    .append('text')
    .attr('id', 'overlap-frame-number-text')
    .text('Frame: 0')
    
}